import { useQuery } from '@tanstack/react-query'
import { createFileRoute, useNavigate, useParams, useSearch } from '@tanstack/react-router'
import { WargaLogin } from '../../../../components/WargaLogin'

export const Route = createFileRoute('/desa/$slug/warga/login')({
  validateSearch: (search: Record<string, unknown>) => ({
    redirect: typeof search.redirect === 'string' ? search.redirect : undefined,
  }),
  component: LoginPage,
})

function LoginPage() {
  const params = useParams({ strict: false }) as { slug?: string }
  const slug = params.slug ?? ''
  const navigate = useNavigate()
  const { redirect } = useSearch({ from: '/desa/$slug/warga/login' })

  const { data: desa } = useQuery({
    queryKey: ['public', 'desa', slug],
    queryFn: async () => {
      const res = await fetch(`/api/public/desa/${slug}`)
      if (!res.ok) return null
      return res.json() as Promise<{ nama: string; nama_ai: string | null; wa_number: string | null }>
    },
    staleTime: 60_000,
  })

  const desaName = desa?.nama ?? slug.replace(/-/g, ' ').replace(/\b\w/g, (c: string) => c.toUpperCase())
  const aiName = desa?.nama_ai ?? 'Jenna'

  return (
    <WargaLogin
      desaSlug={slug}
      desaName={desaName}
      aiName={aiName}
      waNumber={desa?.wa_number ?? null}
      onSuccess={() => navigate({ to: (redirect || `/desa/${slug}/warga`) as any })}
    />
  )
}
